// import * as React from 'react';
import Avatar from '@mui/material/Avatar';
// import Chip from '@mui/material/Chip';
import { GridCellParams, GridColDef } from '@mui/x-data-grid';
// import { SparkLineChart } from '@mui/x-charts/SparkLineChart';

// type SparkLineData = number[];

// function getDaysInMonth(month: number, year: number) {
//   const date = new Date(year, month, 0);
//   const monthName = date.toLocaleDateString('en-US', {
//     month: 'short',
//   });
//   const daysInMonth = date.getDate();
//   const days = [];
//   let i = 1;
//   while (days.length < daysInMonth) {
//     days.push(`${monthName} ${i}`);
//     i += 1;
//   }
//   return days;
// }

// function renderSparklineCell(params: GridCellParams<SparkLineData, any>) {
//   const data = getDaysInMonth(4, 2024);
//   const { value, colDef } = params;

//   if (!value || value.length === 0) {
//     return null;
//   }

//   return (
//     <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
//       <SparkLineChart
//         data={value}
//         width={colDef.computedWidth || 100}
//         height={32}
//         plotType="bar"
//         showHighlight
//         showTooltip
//         colors={['hsl(210, 98%, 42%)']}
//         xAxis={{
//           scaleType: 'band',
//           data,
//         }}
//       />
//     </div>
//   );
// }


// function renderStatus(status: 'Online' | 'Offline') {
//   const colors: { [index: string]: 'success' | 'default' } = {
//     Online: 'success',
//     Offline: 'default',
//   };

//   return <Chip label={status} color={colors[status]} size="small" />;
// }

export function renderAvatar(
  params: GridCellParams<{ name: string; color: string }, any, any>,
) {
  if (params.value == null) {
    return '';
  }

  return (
    <Avatar
      sx={{
        backgroundColor: params.value.color,
        width: '24px',
        height: '24px',
        fontSize: '0.85rem',
      }}
    >
      {params.value.name.toUpperCase().substring(0, 1)}
    </Avatar>
  );
}


export const tariffColumns: GridColDef[] = [
  { field: 'full_name', 
    headerName: 'Product name', 
    flex: 2.0, 
    minWidth: 270,
    maxWidth: 400,
    renderCell: (params) => (
      <div style={{ 
        textAlign: 'left', 
        width: '100%',
        whiteSpace: 'normal',
        wordWrap: 'break-word'
      }}>
        {params.formattedValue}
      </div>
    )
  },
  { field: 'start_date', 
    headerName: 'Start date', 
    headerAlign: 'center',
    flex: 1.0, 
    minWidth: 100,
    valueFormatter: (params) => new Date(params).toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: '2-digit' })
  },
  { field: 'end_date', 
    headerName: 'End date', 
    headerAlign: 'center',
    flex: 1.0, 
    minWidth: 100,
    valueFormatter: (params) => new Date(params).toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: '2-digit' })
  },
  {
    field: 'value_inc_vat',
    headerName: 'Standing charge (p / day)',
    headerAlign: 'center',
    flex: 1.0,
    minWidth: 100,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : ''
  },
  {
    field: 'cost_inc_vat',
    headerName: 'Standing charges (£)',
    headerAlign: 'center',
    flex: 1.0,
    minWidth: 100,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : ''
  },
]


export const columnsNoAggregation: GridColDef[] = [
  { field: 'reading_time', 
    headerName: 'Time', 
    flex: 1.0, 
    minWidth: 80,
    valueFormatter: (params) => new Date(params).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }),
    renderCell: (params) => ( <div style={{ textAlign: 'left', width: '100%' }}>{params.formattedValue}</div>)
  },
  {
    field: 'value_inc_vat',
    headerName: 'Price (p / kWh)',
    headerAlign: 'center',
    flex: 1.0,
    minWidth: 80,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : ''
  },
  {
    field: 'consumption',
    headerName: 'Usage (kWh)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : 'No data'
  },
  {
    field: 'cost_inc_vat',
    headerName: 'Cost (p)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(3) : ''
  },
  {
    field: 'gCO_2',
    headerName: 'CO₂ emitted (g)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number | null) => (x !== null) ? x.toFixed(2) : ''
  }
];


export const columnsAggregatedDay: GridColDef[] = [
  { field: 'reading_time', 
    headerName: 'Day', 
    flex: 1.0, 
    minWidth: 60,
    valueFormatter: (params) => new Date(params).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }),
    renderCell: (params) => ( <div style={{ textAlign: 'left', width: '100%' }}>{params.formattedValue}</div>)
  },
  {
    field: 'value_inc_vat',
    headerName: 'Avg. Price (£ / kWh)',
    headerAlign: 'center',
    flex: 1.0,
    minWidth: 80,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : ''
  },
  {
    field: 'consumption',
    headerName: 'Usage (kWh)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : 'No data'
  },
  {
    field: 'cost_inc_vat',
    headerName: 'Cost (£)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : ''
  },
  {
    field: 'gCO_2',
    headerName: 'CO₂ emitted (kg)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number | null) => (x !== null) ? x.toFixed(2) : ''
  }
];


export const columnsAggregatedWeek: GridColDef[] = [
  { field: 'reading_time', 
    headerName: 'Week', 
    flex: 1.0, 
    minWidth: 120,
    valueFormatter: (params) => {
      let dt = new Date(params);
      let to = dt.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
      let from = new Date(dt.setDate(dt.getDate() - 6)).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
      return from + " - " + to
    },
    renderCell: (params) => ( <div style={{ textAlign: 'left', width: '100%' }}>{params.formattedValue}</div>)
  },
  {
    field: 'value_inc_vat',
    headerName: 'Avg. Price (£ / kWh)',
    headerAlign: 'center',
    flex: 1.0,
    minWidth: 80,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : ''
  },
  {
    field: 'gCO_2_per_kWh',
    headerName: 'Avg. CO₂ intensity (kg / kWh)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number) => (x !== null) ? x.toFixed(0) : null
  },
  {
    field: 'consumption',
    headerName: 'Usage (kWh)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : 'No data'
  },
  {
    field: 'cost_inc_vat',
    headerName: 'Cost (£)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : ''
  },
  {
    field: 'gCO_2',
    headerName: 'CO₂ emitted (kg)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number | null) => (x !== null) ? x.toFixed(2) : ''
  }
];


export const columnsAggregatedMonth: GridColDef[] = [
  { field: 'reading_time', 
    headerName: 'Month', 
    flex: 1.0, 
    minWidth: 80,
    valueFormatter: (params) => new Date(params).toLocaleDateString('en-GB', { month: 'short', year: '2-digit' }),
    renderCell: (params) => ( <div style={{ textAlign: 'left', width: '100%' }}>{params.formattedValue}</div>)
  },
  {
    field: 'value_inc_vat',
    headerName: 'Avg. Price (£ / kWh)',
    headerAlign: 'center',
    flex: 1.0,
    minWidth: 80,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : ''
  },
  {
    field: 'consumption',
    headerName: 'Usage (kWh)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : 'No data'
  },
  {
    field: 'cost_inc_vat',
    headerName: 'Cost (£)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : ''
  },
  {
    field: 'gCO_2',
    headerName: 'CO₂ emitted (kg)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number | null) => (x !== null) ? x.toFixed(2) : ''
  }
];


export const columnsAggregatedYear: GridColDef[] = [
  { field: 'reading_time', 
    headerName: 'Year', 
    flex: 1.0, 
    minWidth: 60,
    valueFormatter: (params) => new Date(params).toLocaleDateString('en-GB', { year: 'numeric' }),
    renderCell: (params) => ( <div style={{ textAlign: 'left', width: '100%' }}>{params.formattedValue}</div>)
  },
  {
    field: 'value_inc_vat',
    headerName: 'Avg. Price (£ / kWh)',
    headerAlign: 'center',
    flex: 1.0,
    minWidth: 80,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : ''
  },
  {
    field: 'consumption',
    headerName: 'Usage (kWh)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : 'No data'
  },
  {
    field: 'cost_inc_vat',
    headerName: 'Cost (£)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number | null) => x !== null ? x.toFixed(2) : ''
  },
  {
    field: 'gCO_2',
    headerName: 'CO₂ emitted (kg)',
    headerAlign: 'center',
    flex: 1,
    minWidth: 80,
    valueFormatter: (x: number | null) => (x !== null) ? x.toFixed(2) : ''
  }
];

export const cheapestTariffsColumns: GridColDef[] = [
  {
    field: 'rank',
    headerName: 'Rank',
    headerAlign: 'center',
    flex: 0.5,
    minWidth: 60,
    maxWidth: 60,
    valueFormatter: (value) => `#${value}`,
    renderCell: (params) => (
      <div style={{ 
        textAlign: 'center', 
        width: '100%',
        fontWeight: params.row.is_current_tariff ? 'bold' : 'normal',
        color: params.row.is_current_tariff ? '#1976d2' : 'inherit'
      }}>
        #{params.value}
      </div>
    )
  },
  { 
    field: 'display_name', 
    headerName: 'Tariff Name', 
    flex: 2.5, 
    minWidth: 330,
    maxWidth: 400,
    valueFormatter: (value) => value, // Ensure we get the raw value
    renderCell: (params) => (
      <div style={{ 
        textAlign: 'left', 
        width: '100%',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        fontWeight: params.row.is_current_tariff ? 'bold' : 'normal'
      }}>
        {params.value} {/* Use params.value instead of params.formattedValue */}
        {params.row.is_current_tariff && (
          <span style={{ 
            marginLeft: '8px', 
            fontSize: '0.75rem', 
            color: '#1976d2',
            fontWeight: 'bold'
          }}>
            (Current)
          </span>
        )}
      </div>
    )
  },
  {
    field: 'total_cost_inc_vat',
    headerName: 'Electricity Used',
    headerAlign: 'center',
    flex: 1.0,
    minWidth: 100,
    valueFormatter: (x: number | null) => x !== null ? `£${x.toFixed(2)}` : 'No data'
  },
  {
    field: 'standing_cost_inc_vat',
    headerName: 'Standing charges',
    headerAlign: 'center',
    flex: 1.0,
    minWidth: 100,
    valueFormatter: (x: number | null) => x !== null ? `£${x.toFixed(2)}` : 'No data'
  },
  {
    field: 'combined_cost_inc_vat',
    headerName: 'Total Cost',
    headerAlign: 'center',
    flex: 1.0,
    minWidth: 100,
    valueFormatter: (x: number | null) => x !== null ? `£${x.toFixed(2)}` : 'No data',
    renderCell: (params) => (
      <div style={{ 
        fontWeight: params.row.is_current_tariff ? 'bold' : 'normal',
        color: params.row.is_current_tariff ? '#1976d2' : 'inherit'
      }}>
        £{params.value?.toFixed(2) || '0.00'}
      </div>
    )
  }
];